import { UserRole } from "../auth/access";
import { User } from "../model/user";
import { api } from "./api";

export const getRoleUsers = async (accessToken: string, role: UserRole): Promise<User[]> => {
    const response = await api.get(`/roles/${role.toString()}/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data as User[];
};

export const grantUserRole = async (accessToken: string, userId: string, role: UserRole): Promise<boolean> => {
    const response = await api.post(`/users/${userId}/roles/${role.toString()}`, {
        // empty body
    }, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.status === 200;
};

export const removeUserRole = async (accessToken: string, userId: string, role: UserRole): Promise<boolean> => {
    const response = await api.delete(`/users/${userId}/roles/${role.toString()}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.status === 200;
};

